// extracted by mini-css-extract-plugin
export var headerTitle = "{ProjectsYaml-slug}-module--headerTitle--2jJqQ";
export var description = "{ProjectsYaml-slug}-module--description--1h5C7";
export var meta = "{ProjectsYaml-slug}-module--meta--xK9TX";
export var metatitle = "{ProjectsYaml-slug}-module--metatitle--SC1_R";